/**
 * 通用格式化工具函数
 */

/**
 * 格式化文件大小
 */
export function formatFileSize(raw: any): string {
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return "—";

  const formatNumber = (value: number) => {
    const rounded = Math.round(value * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  };

  if (n < 1024 * 1024) return `${Math.ceil(n / 1024)} KB`;
  if (n < 1024 * 1024 * 1024) return `${formatNumber(n / 1024 / 1024)} MB`;
  return `${formatNumber(n / 1024 / 1024 / 1024)} GB`;
}

export function formatPersonalDocumentUploadedAt(value: string | null): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const pad = (part: number) => String(part).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
